import React from 'react';
import { Alert, AlertColor, Box, Tooltip } from "@mui/material";
import Waiting, { LoaderClassNames } from "./waiting";

interface LoadingComponentProps {
    caption?: string;
    severity?: AlertColor;
    indicatorClassName?: LoaderClassNames | "none";
    onClick?: () => void;
    toolTip?:string;
}

const LoadingComponent: React.FC<LoadingComponentProps> = ({ caption, severity, indicatorClassName = "dot-floating", onClick, toolTip }) => {
    const actualComponent = (<Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        onClick={onClick} // Applying onClick prop to the Box component
        sx={{
            cursor: onClick ? 'pointer' : 'default', // Change cursor to pointer if onClick is provided
            // height: "70vh"
        }}
    >
        {caption && <Alert severity={severity || "info"}>{caption}</Alert>}
        {indicatorClassName !== "none" ? <Waiting className={indicatorClassName as LoaderClassNames} /> : <div></div>}
    </Box>)
    return toolTip ? (
        <Tooltip title={toolTip}>
            <span>{actualComponent}</span>
        </Tooltip>
    ) : actualComponent;

};

export default LoadingComponent;
